import React from "react";
import { cn } from "@/lib/utils";

export const inp = "h-8 w-full rounded-[8px] border border-black/[0.1] bg-white px-2 text-[13px] tabular-nums outline-none focus:border-black/[0.3]";
export const sel = "h-8 rounded-[8px] border border-black/[0.1] bg-white px-2 text-[13px] outline-none focus:border-black/[0.3]";
export const th = "px-2 py-1.5 text-left text-[11px] font-medium text-muted-foreground";
export const td = "px-2 py-1.5 align-middle";

export function Num({ value, onChange, min = 0, step = 1, className, testId, placeholder }) {
  return <input type="number" inputMode="decimal" min={min} step={step} value={value ?? ""} placeholder={placeholder} onChange={(e) => onChange(e.target.value === "" ? null : Number(e.target.value))} className={cn(inp, className)} data-testid={testId} />;
}

export function Kilde({ row }) {
  if (row.kilde === "standard") return <span className="text-[11px] text-[hsl(var(--v-assumed))]" title="Standardtall – ikke justert av noen">standard</span>;
  return <span className="text-[11px] text-muted-foreground" title={row.justert_at}>justert{row.justert_av?.name ? ` · ${row.justert_av.name.split(" ")[0]}` : ""}</span>;
}

export function Help({ children }) {
  return <p className="mt-2 text-[12px] leading-relaxed text-muted-foreground">{children}</p>;
}

export function Card({ className, children, ...p }) {
  return <div className={cn("rounded-[16px] border border-black/[0.06] bg-white", className)} {...p}>{children}</div>;
}
